export default function() {
    this.loadBoosts()
}
